/* 
*  Created by SGiri 06/29/2018
*/

import { NgModule } from "@angular/core";
import { WidgetGridComponent } from "~config/widget-grid/widget-grid.component";
import { DashboardDetailComponent } from "~config/dashboard-detail/dashboard-detail.component";
import { KpiGridComponent } from "~config/kpi-grid/kpi-grid.component";
import { NewWidgetComponent } from "~config/new-widget/new-widget.component";
import { NewKpiComponent } from "~config/new-kpi/new-kpi.component";
import { FolderdetailwidgetGridComponent } from "~config/folderdetailwidget-grid/folderdetailwidget-grid.component";
import { SyncwithcognosComponent } from "~config/syncwithcognos/syncwithcognos.component";
import { MappingDialogComponent } from "~config/mapping-dialog/mapping-dialog.component";
import { DialogComponent } from "~config/dashboard-detail/dialog/dialog.component";
import { RepofolderDetailComponent } from "~config/repofolder-detail/repofolder-detail.component";
import { EditComponent } from "~config/edit/edit.component";
import { AgGridModule } from "ag-grid-angular";
import { DashboardService } from "~config/services/dashboard.service";
import { RepofolderService } from "~config/services/repofolder.service";
import { SyncwithcognosService } from "~config/services/syncwithcognos.service";
import { SearchService } from "~config/services/search.service";
import { SearchComponent } from "~config/search/search.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../material/material.module";
import { DataDictionaryComponent } from "./data-dictionary/dataDictionary.component";

@NgModule({
    declarations: [
        WidgetGridComponent,
        DashboardDetailComponent,
        KpiGridComponent,
        EditComponent,
        NewWidgetComponent,
        NewKpiComponent,
        RepofolderDetailComponent,
        FolderdetailwidgetGridComponent,
        SyncwithcognosComponent,
        DialogComponent,
        MappingDialogComponent,
        SearchComponent,
        DataDictionaryComponent
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        MaterialModule,
        AgGridModule.withComponents(
            [EditComponent]
        ),
    ],
    entryComponents: [
        DialogComponent,
        MappingDialogComponent
    ],
    providers: [
        DashboardService,
        RepofolderService,
        SyncwithcognosService,
        SearchService
    ],
})
export class ReportingConfigModule {
}



// WEBPACK FOOTER //
// /azp/_work/1/s/src/app/bi-reporting-config/config.module.ts